<template>
  <div class="p-3">
    <div class="mb-3 text-center">
      <img src="@/static/eSim/image-id-card.png" alt="Id Card" class="w-100" />
    </div>
    <van-button
      @click="handleChecked('1')"
      class="btn btn-primary rounded-3 shadown-primary shadow-1 mb-3"
      block
    >
      {{ $t("esim_take_photo_id_card") }}
    </van-button>

    <!-- Button for passport option -->
    <!-- 
    <van-button @click="handleChecked('2')" class="btn btn-primary rounded-3 shadown-primary shadow-1" block>
      {{ $t("esim_passport") }}
    </van-button>
    -->
  </div>
</template>

<script>
import { Popup, Cell, Button } from "vant";
import { Radio, RadioGroup } from "vant";
import { ActionSheet } from "vant";
import { mapState } from "vuex";
import { CONSTANTS } from "@/helpers/constants";
import { preloadFaceLandmarker } from "@/ultis/faceLandmarkerService.js";
import store from "@/store";

export default {
  name: "Register Information",
  components: {
    [Cell.name]: Cell,
    [Popup.name]: Popup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
  },
  data() {
    return {
      show: false,
      checked: "",
    };
  },
  created() {
    console.log("Register infor Pages");
  },
  computed: {
    ...mapState("userStore", ["profile", "defaultParam"]),
    ...mapState("esimBuyStore", ["orderDetail"]),
    ...mapState("headerStore", ["title"]),
  },
  mounted() {
    preloadFaceLandmarker().then(() => {
      console.log("✅ Preload FaceLandmarker successfully!");
    });
    this.changeTitle(this.$t("esim_register_info"));
  },
  watch: {
    $route: {
      handler: function (value) {
        this.$store.dispatch("headerStore/setTitle", "esim_register_info");
      },
      immediate: true,
    },
  },
  methods: {
    changeTitle(title) {
      const contentData = {
        title: title,
        color: "#ffffff",
        bgColor: this.color_primary(),
      };
      this.$bridge.callHandler("setBarTitle", contentData).then((data) => {});
    },
    color_primary() {
      return CONSTANTS.color_primary;
    },
    onClickOverlay() {
      console.log("click-overlay");
      this.show = false; // Close popup when overlay is clicked
    },
    onClickCloseIcon() {
      console.log("click-close-icon");
      this.show = false; // Close popup when close icon is clicked
    },
    handleChecked(val) {
      this.code = val;
      this.checked = val;
      if (this.code == "1") {
        this.$store.dispatch("verificationInfoStore/setItemCCCD", null);
        this.$store.dispatch("verificationInfoStore/setImgCCCD", null);

        this.$store.dispatch("verificationInfoStore/setItemFaceId", null);
        this.$store.dispatch("verificationInfoStore/setImgFaceId", null);

        this.$store.dispatch("esimBuyStore/orderDetail", {
          ...this.orderDetail,
        });
        this.$router.push({ path: "/id-card" });
      } else if (this.code == "2") {
        this.$store.dispatch("verificationInfoStore/setItemPassport", null);
        this.$store.dispatch("verificationInfoStore/setImgPassport", null);

        this.$store.dispatch("verificationInfoStore/setImgVisa", null);

        this.$store.dispatch("verificationInfoStore/setItemFaceId", null);
        this.$store.dispatch("verificationInfoStore/setImgFaceId", null);

        this.$store.dispatch("esimBuyStore/orderDetail", {
          ...this.orderDetail,
        });
        this.$router.push({ path: "/passport" });
      }
    },
  },
};
</script>

<style scoped></style>
